import { getElement, ifSelectorExist } from "./utils";

// https://gist.github.com/facepalmua/e9ba791d612121bcba95d42cfabd7306 - use this as a reference

export const cf7SpecialTagsFix = () => {
  let body = document.body;

  let pageIdClass = body.className.match(/page-id-(\d+)/);

  if (pageIdClass && pageIdClass.length > 1) {
    let pageIdField = getElement('#page_id__custom');
    if (ifSelectorExist(pageIdField)) {
      pageIdField.value = pageIdClass[1];
    }
  }
}
